import React from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './SendingTabs.css';

interface SendingTabItemProps {
    tab: {
        key: string;
        text: string;
        type: string;
        disabled?: boolean;
    };
    currentTab: string;
    onTabClick: (tab: any) => void;
}

function SendingTabItem({tab, currentTab, onTabClick}: SendingTabItemProps) {
    const {t} = useTranslation('layout');

    const handleTabClick = () => {
        if(tab.disabled) return;
        onTabClick(tab);
    };

    return (
        <css.tabItem
            key={tab.key}
            className={currentTab === tab.key ? 'current' : tab.disabled ? 'disabled' : ''}
            onClick={handleTabClick}
            disabled={tab.disabled}
        >
            <css.tabIcon className={tab.type} />
            <css.tabText>{t(tab.text)}</css.tabText>
        </css.tabItem>
    );
}

export default SendingTabItem;
